import React from 'react';
import './App.css';

const App: React.FC = () => {
    return (
        <div className="App">
            <header className="App-header">
                <h1>
                    Expenses Manager
                </h1>
            </header>
        </div>
    );
}

export default App;
